import React from 'react';
import Router from 'react-router';

import ImmutableRenderComponent from './immutable-render-component';
import QuestionUtil from './question-util';


const Link = Router.Link;

/** QuestionSelector component: shows Featured Questions and lets the user
    select a question.
  */
export default class QuestionSelector extends ImmutableRenderComponent {
  constructor(props) {
    super(props);

    this.state = {
      showElementaryQuestions: true,
    }

    this.onToggleQuestions = this.onToggleQuestions.bind(this);
  }

  /** Function that returns appropriate JSX for the icon to display next
    * to the question for a Diagram / Text-only question.
    */
  questionTypeIcon(isDiagramQuestion, isMultipleChoiceQuestion) {
    const daSuffix = isMultipleChoiceQuestion ? "" : "-DA";
    return (isDiagramQuestion ?
      (<div className="icon icon-diagram">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20px" height="20px">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M29.4,5.514c0,7.003,0,13.974,0,20.972c-9.602,0-19.182,0-28.8,0 c0-6.973,0-13.956,0-20.972C10.178,5.514,19.77,5.514,29.4,5.514z M2.906,24.205c8.068,0,16.104,0,24.17,0c0-5.48,0-10.938,0-16.419 c-8.068,0-16.104,0-24.17,0C2.906,13.268,2.906,18.725,2.906,24.205z M20.186,15.56c-1.09,0.889-2.121,1.729-3.176,2.59 c-2.117-2.885-4.21-5.739-6.349-8.654c-2.031,4.354-4.028,8.632-6.04,12.949c6.933,0,13.788,0,20.731,0 C23.602,20.113,21.896,17.84,20.186,15.56z M22.818,9.803c-1.143-0.012-2.055,0.876-2.057,2.001 c-0.004,1.092,0.916,2.013,2.01,2.015c1.104,0.001,2.018-0.897,2.027-1.992C24.809,10.716,23.926,9.814,22.818,9.803z" />
        </svg>
        DIAGRAM{daSuffix}
      </div>) :
      (<div className="icon icon-text">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20px" height="20px">
          <path d="M27.292,10H2.708c-1.104,0-2-0.896-2-2s0.896-2,2-2h24.584c1.104,0,2,0.896,2,2S28.396,10,27.292,10z M27.292,18H2.708 c-1.104,0-2-0.896-2-2c0-1.104,0.896-2,2-2h24.584c1.104,0,2,0.896,2,2C29.292,17.104,28.396,18,27.292,18z M14.5,26H2.708 c-1.104,0-2-0.896-2-2s0.896-2,2-2H14.5c1.104,0,2,0.896,2,2S15.604,26,14.5,26z" />
        </svg>
        TEXT{daSuffix}
      </div>));
  }

  renderQuestion(item, ix) {
    const children = (
      <span className="flex-row">
        {this.questionTypeIcon(QuestionUtil.isDiagramQuestion(item.questionText), QuestionUtil.isMultipleChoiceQuestion(item.questionText))}
        <div className="ask-question">
          {QuestionUtil.questionTextForRenderOnHomepage(item.questionText)}
        </div>
      </span>);
    if (this.props.internalMode) {
      return (
        <li key={ix} className="featured-question link" onClick={this.props.onQuestionClicked.bind(undefined, item.questionText)}>
          <a>{children}</a>
        </li>
      );
    }
    else {
      return (
        <li>
          <Link to="ask" query={{ q: item.questionText }}>
            {children}
          </Link>
        </li>
      );
    }
  }

  // padding on buttons
  onToggleQuestions() {
    this.setState({
      showElementaryQuestions: !this.state.showElementaryQuestions,
    });
  }

  /** Renders the featured questions to select from.
    */
  render() {
    const elementaryQuestions = this.props.questions.filter((q) => { return q.gradeLevel === "elementary"; });
    const middleQuestions = this.props.questions.filter((q) => { return q.gradeLevel === "middle"; });

    const elementaryQuestionsList = elementaryQuestions.map((item, i) => this.renderQuestion(item, i));
    const middleQuestionsList = middleQuestions.map((item, i) => this.renderQuestion(item, i));

    const questionSelectionHeaderSection = this.state.showElementaryQuestions ?
      (
        <div>
          <h1 className="no-bottom-margin">Select an Elementary School Question</h1>
          <button className="button top-margin small-text" onClick={this.onToggleQuestions}>Show Middle School Questions</button>
        </div>
      ) :
      (
        <div>
          <h1 className="no-bottom-margin">Select a Middle School Question</h1>
          <button className="button top-margin small-text" onClick={this.onToggleQuestions}>Show Elementary School Questions</button>
        </div>
      );
    // Return the overall JSX to render, which includes the Question Source on top, followed by the box with a pointer
    // containing the actual questions, one per row.
    const elementaryQuestionsCSS = this.state.showElementaryQuestions ? "bordered-list featured-questions elementary-school-questions" : "bordered-list featured-questions elementary-school-questions hidden";
    const middleQuestionsCSS = this.state.showElementaryQuestions ? "bordered-list featured-questions middle-school-questions hidden" : "bordered-list featured-questions middle-school-questions";
    const content =
      (<div className="text-center">
        {questionSelectionHeaderSection}
        <div className="box-with-pointer text-left no-padding">
          <div className="box-pointer"></div>
          <div className="box-with-pointer-content text-left no-padding">
            <ul className={elementaryQuestionsCSS}>
              {elementaryQuestionsList}
            </ul>
            <ul className={middleQuestionsCSS}>
              {middleQuestionsList}
            </ul>
          </div>
        </div>
      </div>);

    return content;
  }
}
